<div class="container">
  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
</div>
